"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flex = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const utils_1 = require("@bemlo/utils");
const create_styles_1 = require("../utils/create-styles");
const FLEX_VALUE_MAP = {
    around: 'space-around',
    auto: 'auto',
    baseline: 'baseline',
    between: 'space-between',
    center: 'center',
    end: 'flex-end',
    evenly: 'space-evenly',
    normal: 'normal',
    start: 'flex-start',
    stretch: 'stretch',
};
const flexShorthands = (0, utils_1.arrayOfAll)()([
    'col',
    'columnGap',
    'content',
    'gap',
    'grow',
    'items',
    'justify',
    'justifyItems',
    'justifySelf',
    'reverse',
    'rowGap',
    'self',
    'shrink',
    'styles',
    'wrap',
]);
/**
 * Adapted from Tailwind CSS.
 *
 * @see https://tailwindcss.com/docs/align-content
 * @see https://tailwindcss.com/docs/align-items
 * @see https://tailwindcss.com/docs/align-self
 * @see https://tailwindcss.com/docs/justify-content
 * @see https://tailwindcss.com/docs/justify-items
 * @see https://tailwindcss.com/docs/justify-self
 */
exports.Flex = (0, styled_1.default)('div', {
    shouldForwardProp: (prop) => !flexShorthands.includes(prop),
})((props) => {
    const flexDirection = props.col
        ? props.reverse
            ? 'column-reverse'
            : 'column'
        : props.reverse
            ? 'row-reverse'
            : undefined;
    return {
        ...(props.content ? { alignContent: FLEX_VALUE_MAP[props.content] } : {}),
        ...(props.items ? { alignItems: FLEX_VALUE_MAP[props.items] } : {}),
        ...(props.self ? { alignSelf: FLEX_VALUE_MAP[props.self] } : {}),
        ...(props.justify ? { justifyContent: FLEX_VALUE_MAP[props.justify] } : {}),
        ...(props.justifyItems
            ? { justifyItems: FLEX_VALUE_MAP[props.justifyItems] }
            : {}),
        ...(props.justifySelf
            ? { justifySelf: FLEX_VALUE_MAP[props.justifySelf] }
            : {}),
        ...(flexDirection ? { flexDirection } : {}),
        ...(0, create_styles_1.createStyles)({
            ...(props.columnGap ? { columnGap: props.columnGap } : {}),
            ...(props.gap ? { gap: props.gap } : {}),
            ...(props.grow !== undefined ? { flexGrow: props.grow } : {}),
            ...(props.rowGap ? { rowGap: props.rowGap } : {}),
            ...(props.shrink !== undefined ? { flexShrink: props.shrink } : {}),
            ...(props.wrap !== undefined
                ? { flexWrap: props.wrap === true ? 'wrap' : props.wrap }
                : {}),
            ...props.styles,
        }),
        display: 'flex',
    };
});
